import { developerRootRoute } from './root'
import { apiKeyRoute } from './apiKey'
import { apiLogRoute } from './apiLogs'
import { failureLogsRoute } from './failureLogs'

export const developerRoute = developerRootRoute.addChildren([apiKeyRoute, apiLogRoute, failureLogsRoute])
